import { z } from 'zod'

const StringType = z.string()

export const ensureString = (value: unknown) => StringType.parse(value)
